/* Favoritter uden login: gemmes i localStorage under "sfs:favorites" som [{id}], nyeste foerst.
   Hjerter paa kort: button[data-sfs-fav]. Taeller i headeren: [data-sfs-fav-count]. Side: <sfs-favorites>. */
(() => {
  // Theme editor kan koere scriptet igen naar headeren gen-renderes. To click-listeners ville toggle hinanden tilbage.
  if (customElements.get('sfs-favorites')) return;

  const KEY = 'sfs:favorites';
  const MAX = 99; // ponytail: aeldste ryger ud ved 100, saa taelleren altid kan staa med to cifre
  const WATCH = '[data-sfs-fav], [data-sfs-fav-count]';
  let memory = null; // saettes naar localStorage ikke kan skrives (privat tilstand, fuldt lager), saa klik stadig virker paa siden
  const undo = new Map(); // id -> plads i listen, saa et fortrudt klik laegger produktet tilbage hvor det stod

  const read = () => {
    if (memory) return memory;
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      if (Array.isArray(list)) {
        const seen = new Set();
        return list
          .filter((item) => item && Number.isSafeInteger(item.id) && item.id > 0 && !seen.has(item.id) && seen.add(item.id))
          .slice(0, MAX);
      }
    } catch (e) {}
    return [];
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
      memory = null;
    } catch (e) {
      memory = list;
    }
  };

  // Etiketten er fast ("Gem X som favorit"), tilstanden ligger kun i aria-pressed
  const sync = () => {
    const ids = new Set(read().map((item) => String(item.id)));
    document.querySelectorAll('[data-sfs-fav]').forEach((button) => {
      const on = String(ids.has(button.dataset.sfsFav));
      if (button.getAttribute('aria-pressed') !== on) button.setAttribute('aria-pressed', on);
    });
    document.querySelectorAll('[data-sfs-fav-count]').forEach((bubble) => {
      const text = ids.size ? String(ids.size) : '';
      if (bubble.textContent !== text) bubble.textContent = text;
    });
  };

  // Capture-fase: hjertet ligger oven paa kortet, og klikket skal hverken navigere eller naa temaets egne handlers.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-sfs-fav]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const id = Number(button.dataset.sfsFav);
    const list = read().slice();
    const index = list.findIndex((item) => item.id === id);
    if (index > -1) {
      undo.set(id, index);
      list.splice(index, 1);
    } else {
      list.splice(undo.has(id) ? undo.get(id) : 0, 0, { id });
      undo.delete(id);
    }
    write(list.slice(0, MAX));
    sync();
  }, true);

  // Andre faner, og sider der kommer tilbage fra browserens cache
  window.addEventListener('storage', (event) => {
    if (event.key === KEY || event.key === null) sync();
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) sync();
  });

  // Kort der kommer ind via AJAX (filtre, uendelig scroll, anbefalinger, senest sete) og en gen-renderet header.
  // Callbacken koerer foer naeste paint, saa et gemt hjerte aldrig naar at blive vist tomt.
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) =>
      node.nodeType === 1 && (node.matches(WATCH) || node.querySelector(WATCH))
    ))) sync();
  }).observe(document.body, { childList: true, subtree: true });

  sync();

  // Favoritsiden: hent kortene via section rendering, samme moenster som temaets "senest sete"
  class SfsFavorites extends HTMLElement {
    connectedCallback() {
      const ids = read().map((item) => item.id);
      if (!ids.length) return this.show('.sfs-favs__empty');
      fetch(this.dataset.url + encodeURIComponent(ids.map((id) => 'id:' + id).join(' OR ')))
        .then((response) => {
          if (!response.ok) throw new Error('Favoritter: HTTP ' + response.status);
          return response.text();
        })
        .then((html) => {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('sfs-favorites');
          if (!fresh) throw new Error('Favoritter: sfs-favorites mangler i svaret');
          // Slettede eller skjulte produkter kommer ikke med i svaret. De ryger af listen, saa taelleren passer med siden.
          const found = new Set(Array.from(fresh.querySelectorAll('[data-sfs-fav]'), (button) => Number(button.dataset.sfsFav)));
          const list = read();
          const kept = list.filter((item) => found.has(item.id) || !ids.includes(item.id));
          if (kept.length < list.length) write(kept);
          this.innerHTML = fresh.innerHTML;
          sync();
        })
        .catch((error) => {
          console.error(error);
          this.show('.sfs-favs__error');
        });
    }

    show(selector) {
      const element = this.querySelector(selector);
      if (element) element.hidden = false;
    }
  }
  customElements.define('sfs-favorites', SfsFavorites);
})();
